import React from "react";
import _ from "lodash";
import { connect } from "formik";
import num from "numeral";
import { PercentInput } from "components/Global/FormikMaterial";

import ViewOnlyDiv from "./ViewOnlyDiv";
import LateralField from "./LateralField";

const SideLabelPercentInput = ({ label, fieldName, placeholder, decimalScale, formik, isDisabled, ...otherProps }) => {
  const val = _.get(formik.values, fieldName);

  return (
    <LateralField label={label}>
      {isDisabled && <ViewOnlyDiv>{val ? num(val / 100.0).format("0.000%") : ""}</ViewOnlyDiv>}
      {!isDisabled && <PercentInput
        fullWidth
        fieldName={fieldName}
        decimalScale={decimalScale}
        placeholder={placeholder}
        {...otherProps}
      />}
    </LateralField>
  );
};
export default connect(SideLabelPercentInput);
